var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"tag":_vm.tag,"to":{ name: 'Login' }}},[_c('objekto-logo',{staticClass:"fill-current mb-8 h-20"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }